import { useMediaQuery } from "react-responsive";
import VerifyOtpDesktop from "./web/VerifyOtpDesktop";
import VerifyOtpMobile from "./mobile/VerifyOtpMobile";

const LoginPage = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });
  return (
    <div className="bg-bg-main-container">
      {isMobile ? <VerifyOtpMobile /> : <VerifyOtpDesktop />}
    </div>
  );
};

export default LoginPage;
